module.exports = __webpack_public_path__ + "img/box_bg3.9c5ffe5.png";